module.exports = __webpack_public_path__ + "assets/b47.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b47.png
// module id = 635
// module chunks = 0